import React from "react";
import { Link } from "react-router-dom";
import StarIcon from "../components/common/StarIcon";
import "./HomePage.css";

const HomePage = () => {
  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <div className="hero-text">
            <div className="hero-logo">
              <img
                src="/logos/star-logo.png"
                alt="Star Deli Logo"
                width="400"
                height="200"
                fetchpriority="high"
                decoding="async"
              />
            </div>
            <p>
              Classic deli sandwiches, homemade soups, and salads made with the
              finest ingredients
            </p>
            <div className="cta-buttons">
              <Link to="/menu" className="btn primary">
                View Our Menu
              </Link>
              <a href="tel:248-352-7377" className="btn secondary">
                Call To order
              </a>
            </div>
          </div>
          <div className="hero-case" aria-label="Star Deli catering trays and fresh deli food">
            <figure>
              <img
                src="/images/catering/meat-tray.jpg"
                alt="Deli meat tray with pickles and olives"
                width="400"
                height="300"
                loading="lazy"
                decoding="async"
              />
            </figure>
            <figure>
              <img
                src="/images/catering/veggie-tray.jpg"
                alt="Fresh vegetable catering tray"
                width="400"
                height="300"
                loading="lazy"
                decoding="async"
              />
            </figure>
            <figure>
              <img
                src="/images/catering/dessert-tray.jpg"
                alt="Dessert tray for catering"
                width="400"
                height="300"
                loading="lazy"
                decoding="async"
              />
            </figure>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features">
        <div className="container">
          <div className="feature-card">
            <div className="feature-icon">
              <StarIcon name="sandwich" />
            </div>
            <h3>The Authentic Deli Experience</h3>
            <p>
              Our recipes have been passed down through generations, giving you
              a taste of traditional Jewish delicatessen that's impossible to
              find elsewhere.
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">
              <StarIcon name="carrot" />
            </div>
            <h3>Real Ingredients</h3>
            <p>
              Our meats, cheeses, and produce come from the same trusted
              suppliers we've worked with for years. No shortcuts, no
              substitutions — just the ingredients we'd serve our own family.
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">
              <StarIcon name="clock" />
            </div>
            <h3>Fast Takeout Service</h3>
            <p>
              Call ahead and your order will be hot, fresh, and ready when you
              arrive. Perfect for busy lunch breaks or family dinners.
            </p>
          </div>
        </div>
      </section>

    </div>
  );
};

export default HomePage;
